<template>
  <div class="app-container">
    <list ref="list"></list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sys/ulog/list";

export default {
  name: "ulog",
  mixins: [curdMixins],
  components: {
    list,
  },
  methods: {},
};
</script>